import classNames from "classnames";
import { DateFieldProps } from "model/object/fields";
import { createRef } from "react";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { RxCalendar } from "react-icons/rx";
import styles from "./field.module.css";

const DateField = ({
	label,
	value = null,
	onChange,
	error,
	minDate,
	maxDate,
	className,
	iconClassName,
	iconPosition = "left",
	formControlClassName = "",
	disabled = false,
	hasAsterisk = false,
	onBlur,
}: DateFieldProps) => {
	const ref = createRef<DatePicker>();

	return (
		<>
			{label && (
				<Form.Label>
					{label} {hasAsterisk && <span className="text-red">*</span>}
				</Form.Label>
			)}
			<div
				onClick={() => {
					if (ref.current) {
						if (!ref.current.isCalendarOpen()) {
							ref.current.setOpen(true);
						}
					}
				}}
				className={classNames(`d-flex form-control align-items-center flex-row ${styles.field} ${formControlClassName}`, { "is-invalid": error })}
				style={{
					lineHeight: 1.3,
				}}
			>
				{iconPosition === "left" && (
					<div className={`float-left ${iconClassName}`} style={{ color: "#29b9dd" }}>
						<RxCalendar />
					</div>
				)}
				<div className="float-left" style={{ width: "100%" }}>
					<DatePicker
						ref={ref}
						placeholderText="DD/MM/YYYY"
						className={`w-100 border-0 ${styles.field} ${className}`}
						dateFormat="dd/MM/yyyy"
						selected={value}
						onChange={onChange}
						minDate={minDate}
						maxDate={maxDate}
						scrollableYearDropdown
						showYearDropdown
						showMonthDropdown
						yearDropdownItemNumber={100}
						dropdownMode="select"
						popperPlacement="top-end"
						popperModifiers={[
							{
								name: "offset",
								options: {
									offset: [5, 10],
								},
							},
							{
								name: "preventOverflow",
								options: {
									rootBoundary: "viewport",
									tether: false,
									altAxis: true,
								},
							},
						]}
						disabled={disabled}
						onBlur={onBlur}
					/>
				</div>
				{iconPosition === "right" && (
					<div className={`float-right ${iconClassName}`} style={{ color: "#29b9dd" }}>
						<RxCalendar />
					</div>
				)}
			</div>

			{error && <div className="invalid-feedback block">{error}</div>}
		</>
	);
};

export default DateField;
